import { isMatch as isMatchFns } from 'date-fns';

export default function isMatch(date: string, pattern: string): boolean {
  return isMatchFns(date, pattern);
}
